import { useSelector } from 'react-redux';
import { SessionEndingModal } from '../../common/SessionEndingModal';
import { useSessionExpiredChecker } from '../../common/hooks/useSessionExpiredChecker';
import { NotificationContainer } from '../NotificationContainer/NotificationContainer.js';
import { SmallHeader } from '../SmallHeader/SmallHeader.js';
import { DialogContainer } from './selfServiceDialogs.js';
import type { State } from '../../selfservice/common/store.js';
import type { ReactNode } from 'react';

import './SelfService.scss';

export interface SelfServiceChildren {
  children: ReactNode;
}

export const SelfService = (props: SelfServiceChildren) => {
  const isVisible = useSelector(
    (state: State) => Boolean(state?.layout?.hideHeaderFooter) && !state?.layout?.hideSmallHeader
  );
  useSessionExpiredChecker();

  return (
    <div className="of-selfservice" data-testid="of-selfservice">
      {isVisible && <SmallHeader />}
      <NotificationContainer />
      <SessionEndingModal isEmployee={false} />
      <DialogContainer />
      {props.children}
    </div>
  );
};
